import React from 'react';
export function EmotionalOpening() {
  return <section className="bg-white py-16 md:py-24 px-4 border-t border-gray-100" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-center text-black mb-4 leading-tight" data-id="element-45">
          If you <span className="italic text-soft-gold" data-id="element-46">love</span> your dog,
          let me ask you one honest question
        </h2>

        <h3 className="font-serif text-xl md:text-2xl text-center text-soft-gold italic mb-12" data-id="element-47">
          Do you ever feel like taking the photo is easier than loving the
          result?
        </h3>

        <div className="font-sans text-lg md:text-xl text-gray-800 space-y-6 leading-relaxed" data-id="element-48">
          <p data-id="element-49">Not because your dog isn't beautiful.</p>
          <p data-id="element-50">Not because your phone isn't good enough.</p>
          <p data-id="element-51">
            But because nobody ever showed you how to photograph your dog in a
            simple, practical way.
          </p>

          <p className="font-semibold pt-4" data-id="element-52">So what happens?</p>

          <p data-id="element-53">You take the picture quickly.</p>
          <p data-id="element-54">Your dog moves.</p>
          <p data-id="element-55">The light is wrong.</p>
          <p data-id="element-56">The angle feels awkward.</p>
          <p data-id="element-57">The background looks messy.</p>
          <p data-id="element-58">
            And the moment you wanted to keep… doesn't look the way it felt.
          </p>

          <p className="pt-4" data-id="element-59">
            Later, when you scroll through your gallery, you think:
          </p>
          <p className="italic text-gray-600 border-l-4 border-soft-gold pl-4 py-2 my-4 bg-gray-50" data-id="element-60">
            "That doesn't even capture how adorable they really are."
          </p>

          <p className="font-bold text-xl text-black pt-4" data-id="element-61">
            Dog photography shouldn't feel like that.
          </p>
        </div>
      </div>
    </section>;
}